import React from "react";
import { useGLTF } from "@react-three/drei";

function Piano(props) {
  const { nodes } = useGLTF("/3d_objects/piano.glb");

  React.useEffect(() => {
    props.setLoading(props.loading + 1);
  }, [nodes]);

  return (
    <primitive
      useRef={props.pianoRef}
      object={nodes.Piano_2}
      position={[-8, 2.28, -6]}
      scale={[3, 3, 3]}
      rotation={[0, Math.PI / 4, 0]}
      onPointerEnter={() => props.setOnPiano(true)}
      onPointerMissed={() => props.onPiano && props.setOnPiano(false)}
    />
  );
}

export default Piano;
